export const styles = () => ({
  attributesContainer: {
    maxHeight: 236,
    overflowY: 'scroll',
    overflowX: 'hidden',
    outline: 'none',
  },
  button: {
    height: 36,
    width: 212,
    color: '#1658F3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid rgba(53, 64, 82, 0.1)',
    cursor: 'pointer',
    background: '#ffffff',
    fontSize: 14,
  },
  addAttibute: {
    padding: '8px 12px',
    backgroundColor: 'rgba(90, 152, 247, 0.1)',
    cursor: 'pointer',
  },
  optionTitle: {
    color: 'rgba(53, 64, 82, 0.7)',
    fontSize: 14,
    margin: 0,
  },
  option: {
    margin: '4px 0px 0px',
    color: '#ffffff',
    padding: '1px 8px',
    borderRadius: 50,
    width: 'fit-content',
    fontSize: 14,
    cursor: 'pointer',
    backgroundColor: '#5A98F7',
  },
  container: {
    zIndex: 10000,
    width: 200,
    background: '#ffffff',
    position: 'absolute',
    border: '1px solid rgba(53, 64, 82, 0.1)',
    borderRadius: 5,
    overflow: 'hidden',
  },
})
